import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import OfferCard from '../../components/OfferCard/OfferCard';
import {isOutOfOrder} from '../../utils/functions/Functions';
import {resetHighestPageHit, updateCurrentModalPage, updateShowModalFlag} from '../../redux/app-state-slice';
import './OfferCardPage.scss';

function OfferCardPage({dispatch, customerData, appConfig}) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!customerData.result.value.totalApprovedAmount && isOutOfOrder(customerData)) {
      navigate('/');
    }
    dispatch(resetHighestPageHit());
    if (!customerData.isDealerHostApplication.value) {
      dispatch(updateShowModalFlag(false));
      dispatch(updateCurrentModalPage(''));
    }
  }, []);

  return (
    <div className='ppq--web--offer-card-page'>
      <div className='ppq--web--offer-card-page--mask' />
      <div hidden data-testid='offer-id'>
        {customerData.result?.offerId}
      </div>
      <OfferCard appConfig={appConfig} customerData={customerData} />
    </div>
  );
}

export default OfferCardPage;
